import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

const PersonalData = () => {
  const [text, setText] = useState("");

  useEffect(() => {
    import("md/personal_data.md").then((res) => {
      fetch(res.default)
        .then((res) => res.text())
        .then((res) => setText(res));
    });
  }, []);

  return (
    <main className="text-main pad">
      <div className="container">
        <h3>Согласие на обработку персональных данных</h3>
        <ReactMarkdown children={text} />
      </div>
    </main>
  );
};

export default PersonalData;

